<template>
  <div class="box">
    <ShowGr v-if="showInfo" :showInfo="showInfo"></ShowGr>
  </div>
</template>
<script>
import ShowGr from './show/ShowGr.vue';
const rate = window.outerWidth / 375;
import { certificateGR ,certificateQY} from '@/request/index';

export default {
  metaInfo: {
    title: '测评查询结果',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
      }
    ]
  },
  name: "show",
  components: {
    ShowGr
  },
  data() {
    return {
      showInfo: null,
      selectid:"",
      type:'',
      inqtype:''
    }
  },
  created() {
    this.query();
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
     */
    async query() {

      let { name, code, certtypename, type, inqType, cardid } = this.$route.query;
      this.type = type;
      this.inqtype = inqType;
      try{
        let result;
        result = await certificateGR(certtypename, code, name, cardid); 
        result = result.data;
        if (result.success) {
          this.showInfo = result.data[0];
        } else {
          this.showInfo = null; 
          this.$router.push('/inquery');
        }
      }catch(err){
          this.showInfo = null; 
            this.$router.push('/inquery'); 
      }
    },
    /**
     * nianjian转Array
     * "第一年,第二年,第三年"
     * @param {showInfo} obj 
     * @return showInfo
     */
    dealNianjian(obj) {
      return obj;
    },
    /**
     * 技术支持单位
     * 名称##网址||名称##网址
     * @param {showInfo} obj 
     * @return showInfo
     */
    dealJszcdw(obj) {
      return obj;
    }
  }
};
</script>
<style scoped>
.box {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>